<template>
  <div class="v-dialog">

    <div class="row w-100p">
      <div class="col-11 justify-content-center">
        <h2 class="p-0 m-0">{{ locationName }}</h2>
      </div>
      <div class="col-1 pr-1 justify-content-end">
        <a href="#!"  @click="$emit('close')"><i class="icon-times"></i> </a>
      </div>

    </div>

    <div class="text-center" style="z-index: 100" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>


    <template v-if="json_data">

      <highcharts ref="highcharts"
                  :options="chartOptions"
                  :constructor-type="'chart'"
      >
      </highcharts>

    </template>
    <template v-else>
      Načítavam údaje ...
    </template>
    <div class="text-center mt-3">
      <button @click="$emit('close')" class="button"><i class="icon-times"></i> Zavrieť</button>
    </div>
  </div>
</template>

<script>

import Axios from "axios";
import SHMUconf from "../../shmu_conf";
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Highstock from 'highcharts/modules/stock';
import Accessibility from 'highcharts/modules/accessibility';
import Heatmap from 'highcharts/modules/heatmap';
import {Chart} from 'highcharts-vue';

HighchartsMore(Highcharts);
Highstock(Highcharts);
Accessibility(Highcharts);
Heatmap(Highcharts);

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortWeekdays: ['Ned', 'Pon', 'Uto', 'Str', 'Štv', 'Pia', 'Sob'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
    resetZoom: 'Zrušiť priblíženie'
  },
  global: {
    useUTC: true
  }
});



export default {
  name: "GraphModalComponent",
  components: {
    highcharts: Chart
  },
  props: [
    "json_url",
    "okres",
    "produkt"
  ],
  data() {
    return {
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isLoading: false,
      json_data: null,
      errorMsg: null,
      chartOptions: {},
      produkt_trans: {
        "SPI_oper": {
          "AN": "SPI_AN",
          "FC": "SPI_FC",
          "pb": [
            {
              color: 'rgba(39,64,139,1)',
              to: 99,
              from: 2,
            },
            {
              color: 'rgba(79,148,205,1)',
              to: 2,
              from: 1.5,
            },
            {
              color: 'rgba(135,206,250,1)',
              to: 1.5,
              from: 1,
            },
            {
              color: 'rgb(179,229,252,1)',
              to: 1,
              from: 0.5
            },
            {
              color: 'rgba(217,217,217,1)',
              to: 0.5,
              from: -0.5,
            },
            {
              color: 'rgba(255,238,153,1)',
              to: -0.5,
              from: -1,
            },
            {
              color: 'rgba(255,204,0,1)',
              to: -1,
              from: -1.5,
            },
            {
              color: 'rgba(255,127,80,1)',
              to: -2,
              from: -1.5,
            },
            {
              color: 'rgba(205,55,0,1)',
              to: -2,
              from: -99,
            },

          ],
          "tickInterval": 0.5,
        },
        "SPEI_oper": {
          "AN": "SPEI_AN",
          "FC": "SPEI_FC",
          "pb": [
            {
              color: 'rgba(39,64,139,1)',
              to: 99,
              from: 2,
            },
            {
              color: 'rgba(79,148,205,1)',
              to: 2,
              from: 1.5,
            },
            {
              color: 'rgba(135,206,250,1)',
              to: 1.5,
              from: 1,
            },
            {
              color: 'rgb(179,229,252,1)',
              to: 1,
              from: 0.5
            },
            {
              color: 'rgba(217,217,217,1)',
              to: 0.5,
              from: -0.5,
            },
            {
              color: 'rgba(255,238,153,1)',
              to: -0.5,
              from: -1,
            },
            {
              color: 'rgba(255,204,0,1)',
              to: -1,
              from: -1.5,
            },
            {
              color: 'rgba(255,127,80,1)',
              to: -2,
              from: -1.5,
            },
            {
              color: 'rgba(205,55,0,1)',
              to: -2,
              from: -99,
            },

          ],
          "tickInterval": 0.5,
        },
        "RR90_rozdiel": {
          "AN": "RR90_AN",
          "FC": "RR90_FC",
          "pb": [
            {
              color: '#26456E',
              to: 999,
              from: 150,
            },
            {
              color: '#21538B',
              to: 150,
              from: 125,
            },
            {
              color: '#1C63A1',
              to: 125,
              from: 100,
            },
            {
              color: '#1F74B1',
              to: 100,
              from: 75,
            },
            {
              color: '#3F8BBA',
              to: 75,
              from: 50,
            },
            {
              color: '#5EA5CE',
              to: 50,
              from: 25,
            },
            {
              color: '#BBC5CC',
              to: 25,
              from: 0,
            },
            {
              color: '#E2C4C0',
              to: 0,
              from: -25,
            },
            {
              color: '#F6796A',
              to: -25,
              from: -50
            },
            {
              color: '#E25644',
              to: -50,
              from: -75,
            },
            {
              color: '#D21E1C',
              to: -75,
              from: -100,
            },
            {
              color: '#C51517',
              to: -100,
              from: -125,
            },
            {
              color: '#B3101B',
              to: -125,
              from: -150,
            },
            {
              color: '#9C0824',
              to: -150,
              from: -999,
            },

          ],
          "tickInterval": 5,
        },

      }
    }
  },
  mounted() {
    this.loadJsonFile();
  },
  computed: {
    AN_var() {
      return this.produkt_trans[this.produkt]?.AN ?? null;
    },
    FC_var() {
      return this.produkt_trans[this.produkt]?.FC ?? null;
    },
    locationName() {
      if (this.json_data) {
          return this.json_data.metadata.location_name;
      }
      return this.okres
    },
    forecastStarts() {
      return this.json_data[this.FC_var].data_fc[0][0] * 1000;
    },
    forecastEnds() {
      let d = this.json_data[this.FC_var].data_fc;
      let total = d.length;
      return d[total-1][0] * 1000;
    },
    analyzeValues() {
      let fc = this.json_data[this.FC_var].data_fc;
      let an = this.json_data[this.AN_var].data_an;
      let a = an.map(item => ([item[0] * 1000, item[1]]))
      a.push([fc[0][0] * 1000, fc[0][1]]); // do analyzy dame prvu predpovedanu aby sme spojili seriu
      return a;
    },
    forecastValues() {
      let fc = this.json_data[this.FC_var].data_fc;
      return fc.map(item => ([item[0] * 1000, item[2], item[3]]))
    }
  },
  methods: {
    loadJsonFile() {
      const self = this;
      self.errorMsg = null;
      self.isLoading = true;
      Axios.get(this.json_url, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        self.json_data = response.data;
        self.isLoading = false;
        self.prepareData();
      }).catch((error) => {
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
        console.log(error);
      });
    },
    prepareData() {

      const self = this;

      this.chartOptions = {
        name: 'SPEI',
        id: 'spei',
        credits:false,
        chart : {
          zoomType: 'x',
          resetZoomButton: {
            position: {
              x: -10,
              y: 35
            }
          },
          animation: false,
          credits: false,
          zooming: {
            mouseWheel: {
              enabled: false
            }
          },
          // alignTicks: true,
        },
        title: {
          enabled: true,
          //text:''
          // margin: 0,
          text: this.json_data[this.AN_var].comment + ' - ' + this.$moment(this.json_data.metadata.data_date_time).format('DD.MM.YYYY'),
        },
        subtitle: {
          text: '',
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          valueSuffix: '',
          valueDecimals: 1,
          shared:true,
          formatter: function () {
            return self.tooltipFormatter(this.points)
          },
        },
        xAxis : {
          crosshair: {
            enabled: true,
            width: 10,
          },
          type: 'datetime',
          tickInterval: 24 * 60 * 60 * 1000,
          tickWidth: 2,
          tickLength: 5,
          tickColor: '#000000',
          minorGridLineWidth: 0,
          minorGridLineColor: '#999',
          minorGridLineDashStyle: 'dot',

          // minorTickInterval: 24 * 60 * 60 * 1000,
          // minorTickWidth: 1,
          // minorTickLength: 3,


          // tickInterval: 2 * 60 * 60 * 1000,
          dateTimeLabelFormats: {
            day: '%d.%m.%y',
            month: '%d.%m.',
            year: '%b',
            hour: '%H'
          },
          lineColor: '#000',
          lineWidth: 1,

          gridLineWidth: 1,
          gridLineDashStyle: 'Dot',
          gridLineColor: '#999',
          labels:{
            style: { fontSize:'14px' },
            rotation: 270, x:0, y:12
          },
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          plotLines: [{
              color: 'rgba(0,0,0,0.7)',
              dashStyle: 'dash',
              label: {
                text: 'Predpoveď',
                align: 'left',
                rotation: 0,
                style: {
                  opacity: 0.5,
                },
                x: 10,
                y: 15,
              },
              zIndex: 5,
              value: this.forecastStarts,
          }],
          plotBands: [{
              color: 'rgba(131,131,131,0.1)',
              zIndex: 5,
              from: this.forecastStarts,
              to: this.forecastEnds,
          }],
        },
        yAxis: [{
          title: {enabled: false},
          tickWidth: 1,
          gridLineWidth: 0,
          tickColor: '#000',
          lineWidth: 1,
          lineColor: '#000',

          minorTickInterval: 5,
          minorGridLineWidth: 0,
          minorTickWidth: 1,
          minorTickLength: 5,

          /*
          min:-5,
          max:5,

           */

          animation: false,
          tickInterval: this.produkt_trans[this.produkt]?.tickInterval ?? 0.5,
          plotLines: [{value: 0, color: 'rgba(0,0,0,0.5)', width: 1, zIndex: 2}],
          plotBands: this.produkt_trans[this.produkt]?.pb ?? [],
        },
          {
            linkedTo: 0,
            opposite: true,
            title: {enabled: false},
            lineColor: '#000',
            lineWidth: 1,
            tickWidth: 1,
            tickColor: '#000',
            tickInterval: undefined,
            gridLineWidth: 0,

            minorTickInterval: 5,
            minorGridLineWidth: 0,
            minorTickWidth: 1,
            minorTickLength: 5,

          }
        ],
        series: [
          {
            type: 'areaspline',
            color: 'rgba(0,0,255, 0.7)',
            negativeColor: 'rgba(255,0,0, 0.7)',
            opacity: 1,
            lineWidth: 2,
            name: 'Analýza',
            animation:false,
            showInTooltip: true,
            id: 'an',
            states: {
              hover: {
                lineWidth: 2,
              },
            },
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                  fillColor: '#333333',
                  radius: 3,
                  lineColor: '#333333',
                  lineWidth: 1,
                }
              }
            },
            data: this.analyzeValues
          },
          {
            type: 'areasplinerange',
            color: 'rgba(0,0,255, 0.7)',
            opacity: 1,
            lineWidth: 2,
            animation:false,
            negativeColor: 'rgba(255,0,0, 0.7)',
            dashStyle: 'Solid',
            name: 'Predpoveď 10-90perc',
            id: 'fc_1090',
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                  fillColor: '#333333',
                  radius: 3,
                  lineColor: '#333333',
                  lineWidth: 1,
                }
              }
            },
            data: this.forecastValues
          },
          {
            type: 'spline',
            color: 'rgba(0,0,255, 1)',
            opacity: 1,
            lineWidth: 2,
            negativeColor: 'rgba(255,0,0, 1)',
            name: 'Predpoveď medián',
            animation:false,
            dashStyle: 'Solid',
            id: 'fc_med',
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                  fillColor: '#333333',
                  radius: 3,
                  lineColor: '#333333',
                  lineWidth: 4,
                }
              }
            },
            data: this.json_data[this.FC_var].data_fc.map(item => ([item[0] * 1000, item[1]]))
          }
        ],
        plotOptions : {
          spline: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          areasplinerange: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          series: {
            states: {
              hover: {
                halo: {
                  size: 0
                }
              },
              inactive: {
                enabled: false
              }
            }
          }
        }
      }
    },
    redrawCharts() {
      const self = this;
      if (self.$refs.highcharts.length) {
        self.$refs.highcharts.forEach((cmp) => {
          cmp.chart.redraw();
        });
      }

      this.$nextTick(function() {
        window.dispatchEvent(new Event('resize'));
      });

    },
    formatDate(value, format) {
      let momUTC = this.$moment.utc(value);
      return this.$moment(momUTC).format(format);
    },
    tooltipFormatter(points, v) {
      let i,
          result = '';
      const self = this;

      var x = null;
      function formatPoint(p) {

        if (p.point.y === null) return '';
        if (p.point.y === '') return '';
        if (isNaN(p.point.y)) return '';

        let v_t = p.point.y;
        if (p.point.high) {
          v_t += ' - ' + p.point.high;
        }

        if (!x) {
          x = p.point.x;
        }

        return '<span style="padding-left: 5px; color:' + p.point.color + '">\u25A0</span> ' + p.series.name + ': <b>' + v_t + '</b>&nbsp;&nbsp;<br>'
      }


      for (i = 0; i < points.length; i++) {

        // console.log(points[i].x === self.forecastStarts, points[i].x , self.forecastStarts)
        if (points[i].x === self.forecastStarts && points[i].series.userOptions.id === 'an') {
          continue;
        }
        result += formatPoint(points[i])
      }
      let dt = Highcharts.dateFormat('%d.%m.%Y', new Date(x));
      result = '<b style="padding-bottom: 3px; display: block; font-size: 14px">'+dt + '</b><br><span style="font-size: 13px">' + result + '</span>';

      return result;
    }
  }

}
</script>

<style scoped>

</style>